import React, { useState, useEffect } from 'react'
import './App.css'
import './Profile.css'
import './Marketing.css'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import { IoIosArrowBack, IoIosAttach } from 'react-icons/io'
import { IoMailOutline, IoChatbubbleOutline, IoPeopleOutline, IoEyeOutline } from 'react-icons/io5'
import { IoWarningOutline } from 'react-icons/io5'
import ClipLoader from 'react-spinners/ClipLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { BiMenu } from 'react-icons/bi'
import { SiX } from 'react-icons/si'
import { BsFacebook, BsInstagram, BsTiktok } from 'react-icons/bs'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import Header5 from './components/Header5'
import { API_URL } from './config'

const ICONS = {
  'application/pdf': 'pdf.png',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'word.png',
  'application/vnd.ms-excel': 'excel.png',
  'audio/mpeg': 'mp3.png',
  'video/mp4': 'mp4.png',
}

const Marketing = () => {
  const history = useHistory()
  const [disabled, setDisabled] = useState(false)
  const [x, setX] = useState('#')
  const [instagram, setInstagram] = useState('#')
  const [facebook, setFacebook] = useState('#')
  const [tiktok, setTiktok] = useState('#')
  const [text, setText] = useState('')
  const [subject, setSubject] = useState('')
  const [count, setCount] = useState(0)
  const [phone, setPhone] = useState('')
  const [businessEmail, setBusinessEmail] = useState('')

  const [marketingType, setMarketingType] = useState(localStorage.getItem('type'))
  const [recipients, setRecipients] = useState(localStorage.getItem('audience'))
  const [alias] = useState(localStorage.getItem('alias'))

  const [attachment, setAttachment] = useState('')
  const [attachmentLabel, setAttachmentLabel] = useState('Add attachment')
  const [presAttachment, setPreAttachment] = useState('')
  const [attachmentName, setAttachmentName] = useState('')
  const [type, setType] = useState('')
  const [showAttach, setShowAttach] = useState(true)

  const [loading, setLoading] = useState(false)
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [error, setError] = useState('')
  const [responsebg, setResponseBG] = useState('error-login')

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState(isMobile)
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    document.title = 'Marketing campaign'

    const businessid = localStorage.getItem('businessid')

    axios
      .get(`${API_URL}/apps/kscanner/webservices.php?query=BUSINESSDETAILS`, {
        withCredentials: true,
      })
      .then((response) => {
        setPhone(response.data.phone)
        setBusinessEmail(response.data.email)
        setX(response.data.twitter)
        setInstagram(response.data.instagram)
        setFacebook(response.data.facebook)
        setTiktok(response.data.tiktok)
      })
      .catch((error) => {
        alert(error)
      })

    if (localStorage.getItem('alias') == 'NEWAUDIENCE') {
      axios
        .get(
          `${API_URL}/apps/kscanner/webservices.php?query=GET-AUDIENCE-COUNT&businessid=${businessid}`,
          { withCredentials: true },
        )
        .then((response) => {
          setRecipients(response.data.audience)
        })
        .catch((error) => {
          alert(error)
        })
    }
    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  async function next() {
    setLoading(true)
    setErrorDisplay('none')

    const businessid = localStorage.getItem('businessid')
    const cost = recipients.replace(',', '') * 0.9

    const data = new FormData()
    data.append('file', attachment)
    data.append('businessid', businessid)
    data.append('text', text)
    data.append('subject', subject)
    data.append('subqueryone', marketingType)
    data.append('marketing_type', marketingType)
    data.append('subquerytwo', alias)
    data.append('query', 'EMAIL-MARKETING')
    data.append('recipients_count', recipients.replace(',', ''))
    data.append('cost', cost)

    if (marketingType === 'EMAIL' && subject.trim() === '') {
      setErrorDisplay('block')
      setError('Enter email subject')
      setResponseBG('error-login')
      setLoading(false)
    } else {
      setDisabled(true)
      await axios({
        url: `${API_URL}/apps/kscanner/webservices.php`,
        method: 'POST',
        data: data,
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((response) => {
        setDisabled(false)
        if (marketingType === 'EMAIL') {
          setErrorDisplay('block')
          setError(response.data.message)
          setResponseBG(response.data.status === 'success' ? 'success-login' : 'error-login')
        } else {
          localStorage.setItem('textid', response.data.textid)
          const smsCost = Number(recipients) * 0.9
          history.push({
            pathname: '/smscampaign',
            state: {
              textid: response.data.textid,
              alias: alias,
              audience: recipients,
              cost: smsCost,
              text: text,
              business_email: businessEmail,
            },
          })
        }
        setLoading(false)
      })

      setTimeout(() => {
        setErrorDisplay('none')
      }, 5000)
    }
  }

  function handleText(event) {
    setText(event.target.value)
    setCount(event.target.value.length)
  }

  function email() {
    setMarketingType('EMAIL')
    setShowAttach(false)
    setAttachmentLabel('Add attachment')
    setAttachment('')
    setType('')
    setErrorDisplay('none')
  }

  function sms() {
    setMarketingType('SMS')
    setErrorDisplay('none')
  }

  function removeAttachment() {
    setShowAttach(false)
    setAttachmentLabel('Add attachment')
    setAttachment('')
    setType('')
    setErrorDisplay('none')
  }

  function selectImage(event) {
    const file = event.target.files[0]
    if (!file) return
    setAttachment(file)
    setPreAttachment(URL.createObjectURL(file))
    setAttachmentName(file.name)
    setType(file.type)
    setShowAttach(true)
    setAttachmentLabel('Change attachment')
    setErrorDisplay('none')
  }

  if (localStorage.getItem('businessname') === null) {
    return <Redirect to="/login" />
  } else if (localStorage.getItem('alias') === null) {
    return <Redirect to="/sms" />
  }

  function formatPhoneLocal(phoneNumber) {
    return (phoneNumber || '').replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')
  }

  const businessname = localStorage.getItem('businessname')
  const total = recipients < 1000 ? recipients * 0.9 : recipients.replace(',', '') * 0.9
  const accounttype = localStorage.getItem('accounttype')
  const handleToggle = () => setCollapsed((prev) => !prev)

  const isSms = marketingType === 'SMS'
  const isEmail = marketingType === 'EMAIL'
  const smsOver = count > 130 && isSms
  const sendDisabled = text.trim() === '' || smsOver || disabled
  const lockedAudience = localStorage.getItem('alias') == 'NEWAUDIENCE'
  const hideSms = localStorage.getItem('type') == 'EMAIL' && lockedAudience
  const hideEmail = localStorage.getItem('type') == 'SMS' && lockedAudience

  const linkProps = (url) => ({ href: url, target: url == '#' ? '' : '_blank' })

  return (
    <div className="view">
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
          <Header />
        </>
      ) : accounttype === 'business' ? (
        <>
          <SideNav collapsed={collapsed} onToggle={handleToggle} />
          <Header />
        </>
      ) : (
        <Header5 />
      )}

      {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <main
        className="pf-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? 0 : collapsed ? '76px' : '252px',
        }}
      >
        <div className="pf-container">
          <div className="pf-top">
            <button type="button" className="pf-back" onClick={() => history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <button
              type="button"
              className="pf-edit mk-send"
              onClick={next}
              disabled={sendDisabled}
            >
              {loading ? (
                <ClipLoader color={'#fff'} loading={true} size={16} />
              ) : isSms ? (
                'Proceed'
              ) : (
                'Send'
              )}
            </button>
          </div>

          {/* Channel */}
          <section className="pf-card">
            <div className="pf-card__head">
              <h2>
                <IoChatbubbleOutline size={18} />
                Choose communication
              </h2>
            </div>

            <div className="mk-body">
              <div className="mk-options">
                {!hideSms && (
                  <button
                    type="button"
                    className={`mk-option ${isSms ? 'mk-option--active' : ''}`}
                    onClick={sms}
                  >
                    <IoChatbubbleOutline size={20} />
                    <span>SMS</span>
                  </button>
                )}
                {!hideEmail && (
                  <button
                    type="button"
                    className={`mk-option ${isEmail ? 'mk-option--active' : ''}`}
                    onClick={email}
                  >
                    <IoMailOutline size={20} />
                    <span>Email</span>
                  </button>
                )}
              </div>
            </div>
          </section>

          {/* Message */}
          {isSms ? (
            <section className="pf-card">
              <div className="mk-body mk-notice">
                <IoWarningOutline size={56} />
                <p>
                  SMS communications are temporarily offline. Kindly direct all communication via
                  email.
                </p>
              </div>
            </section>
          ) : (
            <section className="pf-card">
              <div className="pf-card__head">
                <h2>
                  <IoMailOutline size={18} />
                  Message
                </h2>
              </div>

              <div className="mk-body">
                <input
                  type="text"
                  placeholder="Email subject"
                  onChange={(e) => setSubject(e.target.value)}
                  value={subject}
                  className="mk-input"
                />

                <p className="mk-hint">
                  Just write your email message—no need for greetings. Karamale will automatically
                  add them for you.
                </p>

                <textarea
                  placeholder="Type your email message"
                  onChange={handleText}
                  value={text}
                  className="mk-textarea"
                  style={{ height: 300 }}
                />

                <div className="mk-row">
                  <label className="mk-attach" htmlFor="image">
                    <IoIosAttach size={18} /> {attachmentLabel}
                  </label>
                  <span className="mk-muted">No character limit</span>
                </div>

                <input
                  name="file"
                  type="file"
                  onChange={selectImage}
                  id="image"
                  className="hide-file-input-type"
                />
              </div>
            </section>
          )}

          {/* Audience */}
          {!isSms && (
            <section className="pf-card">
              <div className="pf-card__head">
                <h2>
                  <IoPeopleOutline size={18} />
                  Audience
                </h2>
              </div>

              <dl className="pf-grid">
                <div className="pf-field">
                  <dt>Recipients</dt>
                  <dd>
                    {recipients} {recipients == 1 ? 'recipient' : 'recipients'}
                  </dd>
                </div>
                <div className="pf-field">
                  <dt>Cost</dt>
                  <dd>Email marketing is free</dd>
                </div>
                <div className="pf-field">
                  <dt>Total</dt>
                  <dd>R0.0</dd>
                </div>
              </dl>
            </section>
          )}

          {/* Preview */}
          {!isSms && (
            <section className="pf-card">
              <div className="pf-card__head">
                <h2>
                  <IoEyeOutline size={18} />
                  Preview
                </h2>
              </div>

              <div className="mk-body">
                {text.trim() === '' ? (
                  <p className="mk-muted">Your text will appear here the moment you start typing</p>
                ) : (
                  <div className="mk-preview">
                    <div className="mk-preview__logo">
                      <img src={`${API_URL}/karamale.png`} width="150" alt="Karamale" />
                    </div>

                    <p>Hi [Name],</p>
                    <p className="pf-preline">{text}</p>

                    <p>
                      <span className="mk-muted">Contact:</span> {formatPhoneLocal(phone)}
                      <br />
                      <span className="mk-muted">Email:</span> {businessEmail}
                    </p>

                    <p>
                      Warm regards, <br />
                      <strong>{businessname}</strong>
                    </p>

                    <div className="mk-preview__social">
                      <span className="mk-muted">Follow {businessname}</span>
                      <div>
                        <a {...linkProps(x)}>
                          <SiX size={24} color="#000000" />
                        </a>
                        <a {...linkProps(instagram)}>
                          <BsInstagram size={24} color="#d62976" />
                        </a>
                        <a {...linkProps(facebook)}>
                          <BsFacebook size={24} color="#1877F2" />
                        </a>
                        <a {...linkProps(tiktok)}>
                          <BsTiktok size={24} color="#25F4EE" />
                        </a>
                      </div>
                      <span className="mk-muted">
                        This email was sent by Karamale on behalf of
                        <br />
                        {businessname}
                      </span>
                    </div>
                  </div>
                )}

                {showAttach && attachment && (
                  <div className="mk-file">
                    {ICONS[type] || type === 'image/png' || type === 'image/jpeg' ? (
                      type === 'image/png' || type === 'image/jpeg' ? (
                        <img src={presAttachment} className="mk-file__img" alt="Attachment" />
                      ) : (
                        <img
                          src={`${API_URL}/apps/kscanner/icons/${ICONS[type]}`}
                          width={64}
                          alt="Attachment"
                        />
                      )
                    ) : (
                      <img
                        src={`${API_URL}/apps/kscanner/icons/file.png`}
                        width={64}
                        alt="Attachment"
                      />
                    )}
                    {!(type === 'image/png' || type === 'image/jpeg') && (
                      <span className="mk-file__name">{attachmentName}</span>
                    )}
                    <button type="button" className="mk-file__remove" onClick={removeAttachment}>
                      Remove attachment
                    </button>
                  </div>
                )}
              </div>
            </section>
          )}
        </div>
      </main>

      <div className={responsebg + ' text-center'} style={{ display: errorDisplay }}>
        {error}
      </div>
    </div>
  )
}

export default Marketing
